var map = {
	"./1inchwallet.jpg": 79477,
	"./alphawallet.jpg": 76494,
	"./ambirewallet.png": 90853,
	"./ambo.jpg": 20606,
	"./argent.jpg": 17205,
	"./authereum.png": 1931,
	"./bitcoindotcomwallet.jpg": 4360,
	"./blankwallet.jpg": 6057,
	"./blockchaincom.png": 31429,
	"./blocto.png": 94633,
	"./brave.jpg": 14204,
	"./brd.jpg": 49774,
	"./burnerwallet.jpg": 36043,
	"./coinbase.png": 1979,
	"./coinbasewallet.png": 38092,
	"./coinhako.jpg": 60023,
	"./coinomi.jpg": 13448,
	"./dcent.jpg": 99538,
	"./dether.jpg": 50058,
	"./dexwallet.jpg": 12755,
	"./dynalock.jpg": 52476,
	"./edge.jpg": 41814,
	"./eidoo.jpg": 99063,
	"./enjin.jpg": 6165,
	"./frame.jpg": 57811,
	"./frontierwallet.jpg": 90100,
	"./gnosissafe.png": 49230,
	"./gopocket.jpg": 1489,
	"./gridplus.jpg": 97306,
	"./guarda.jpg": 19570,
	"./huobi.jpg": 14820,
	"./imToken.jpg": 67477,
	"./jarvis.png": 23751,
	"./keplr.jpg": 30469,
	"./keystone.jpg": 79837,
	"./leth.jpg": 83531,
	"./mathwallet.jpg": 64980,
	"./metamask.jpg": 21226,
	"./metamaskmobile.jpg": 67916,
	"./multis.jpg": 8404,
	"./myCrypto.jpg": 57253,
	"./myEtherWallet.jpg": 71876,
	"./obvious.png": 13187,
	"./onekey.png": 58405,
	"./opera.jpg": 49854,
	"./ownbit.jpg": 91339,
	"./paytomat.jpg": 10216,
	"./pillar.jpg": 14274,
	"./rainbow.jpg": 50168,
	"./sequencewallet.jpg": 62348,
	"./status.jpg": 85041,
	"./steakwallet.jpg": 64629,
	"./tallywallet.jpg": 12598,
	"./timelesswallet.jpeg": 47259,
	"./tokenpocket.jpg": 24546,
	"./torus.png": 89033,
	"./trusteewallet.jpg": 18960,
	"./trustwallet.png": 692,
	"./unstoppablewallet.jpg": 49515,
	"./venly.jpg": 59966,
	"./walleth.jpg": 57869,
	"./xummwallet.jpg": 2425,
	"./zippie.jpg": 26451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8225;